import React, { useState } from 'react';
import * as emotion from 'emotion';
import * as emotionCore from '@emotion/core';
import * as emotionTheming from 'emotion-theming';
import { parseBrazeEpicParams, } from '@root/src/web/lib/braze/parseBrazeEpicParams';
import { useOnce } from '@root/src/web/lib/useOnce';
import { joinUrl } from '@root/src/lib/joinUrl';
const { css } = emotion;
const wrapperMargins = css `
	margin: 18px 0;
`;
const EPIC_COMPONENT_PATH = '/epic.js';
export const canShow = async (brazeMessagesPromise) => {
    try {
        const brazeMessages = await brazeMessagesPromise;
        const message = await brazeMessages.getMessageForEndOfArticle();
        return {
            result: true,
            meta: {
                dataFromBraze: message.extras,
                logImpressionWithBraze: () => {
                    message.logImpression();
                },
            },
        };
    }
    catch (e) {
        return { result: false };
    }
};
const buildEpicProps = (dataFromBraze, countryCode) => {
    const variant = parseBrazeEpicParams(dataFromBraze);
    if (variant === null)
        return null;
    const pageTracking = {
        ophanPageId: window.guardian.config.ophan.pageViewId,
        platformId: 'GUARDIAN_WEB',
        clientName: 'dcr',
        referrerUrl: window.location.origin + window.location.pathname,
    };
    const tracking = {
        ...pageTracking,
    };
    return { variant, tracking, numArticles: 0, countryCode };
};
const BrazeEpic = ({ contributionsServiceUrl, meta, countryCode, }) => {
    const [Epic, setEpic] = useState();
    useOnce(() => {
        window.guardian.automat = {
            react: React,
            preact: React,
            emotionCore,
            emotionTheming,
            emotion,
        };
        const componentUrl = joinUrl([
            contributionsServiceUrl,
            EPIC_COMPONENT_PATH,
        ]);
        window
            .guardianPolyfilledImport(componentUrl)
            .then((epicModule) => {
            setEpic(() => epicModule.ContributionsEpic); // useState requires functions to be wrapped
            // TODO: log the impression when the epic is in view (using hasBeenSeen probably)
            meta.logImpressionWithBraze();
        })
            .catch((error) => {
            window.guardian.modules.sentry.reportError(error, 'braze-epic');
        });
    }, [contributionsServiceUrl, meta]);
    if (Epic && meta.dataFromBraze) {
        // This will come from Braze via the meta from canShow
        const props = buildEpicProps(meta.dataFromBraze, countryCode);
        if (props) {
            return (React.createElement("div", { className: wrapperMargins },
                React.createElement(Epic, Object.assign({}, props))));
        }
    }
    return null;
};
const NoEpic = () => null;
export const MaybeBrazeEpic = ({ contributionsServiceUrl, meta, countryCode, }) => {
    const componentName = meta.dataFromBraze?.componentName;
    if (componentName === 'Epic') {
        return (React.createElement(BrazeEpic, { contributionsServiceUrl: contributionsServiceUrl, meta: meta, countryCode: countryCode }));
    }
    if (componentName === 'NoEpic') {
        return React.createElement(NoEpic, null);
    }
    return null;
};
